import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import attenderApis from "../../api/attenderControllerApis";
import { Attender } from "../../types/attenderType";

export const fetchAttenders = createAsyncThunk<
  Attender[], 
  number     
>("attenders/fetch", async (studentId) => {
  const res = await attenderApis.getAttenders(studentId);
  return res.data;
});

interface AttenderState {
  list: Attender[];
  loading: boolean;
}

const initialState: AttenderState = {
  list: [],
  loading: false,
};

const attenderSlice = createSlice({
  name: "attenders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttenders.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAttenders.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchAttenders.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default attenderSlice.reducer;
